"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Layout = _interopRequireDefault(require("../Layout"));

var _useRoutes = require("../../hooks/useRoutes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PeractoRoute = function PeractoRoute(_ref) {
  var pathname = _ref.location.pathname;
  var routes = (0, _useRoutes.useRoutes)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, pathname.includes('/content/edit') ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, routes) : /*#__PURE__*/_react["default"].createElement(_Layout["default"], {
    routes: routes
  }));
};

var _default = PeractoRoute;
exports["default"] = _default;